<sd-title
  [titleThemesConfig]="brandThemesEnum.brand"
  class="is-main"
  [titleLevel]="1"
  customClass="brand--h3 is-semi-bold"
>
  {{ "myProduct.title" | translate }}
</sd-title>

<sd-border-wrapper [titleLevel]="2">
  <p class="is-body-s c__description">
    {{ 'myProduct.description' | translate }}
  </p>
  @if (productCustomer?.length > 0) {
    <sd-title
      [titleThemesConfig]="themesTextEnum.dark"
      [titleLevel]="1"
      customClass="is-main brand--h5"
    >
      {{ 'myProduct.titleBrand' | translate }}
    </sd-title>
  }
  <ul sd-list-block>
    @for (product of productCustomer; track product) {
      <li>
        <sd-product-customer
          [indexFollow]="product?.indexFollow"
          [titleLevel]="4"
          [isReadOnly]="true"
          [isRegistered]="true"
          [productInfo]="product"
          (warranty)="productWarranty()"
          (instruction)="productInstruction(product)"
          (delete)="deleteProduct(product)"
        />
      </li>
    }
  </ul>

  @if (productCustomerExtern?.length > 0) {
    <sd-title
      [titleThemesConfig]="themesTextEnum.dark"
      [titleLevel]="1"
      customClass="is-main brand--h5"
    >
      {{ 'myProduct.titleExtern' | translate }}
    </sd-title>
  }
  <ul sd-list-block>
    @for (product of productCustomerExtern; track product) {
      <li>
        <sd-product-customer
          [indexFollow]="product?.indexFollow"
          [titleLevel]="4"
          [isReadOnly]="true"
          [isRegistered]="true"
          [productInfo]="product"
          [displayProductAssets]="false"
          (warranty)="productWarranty()"
          (instruction)="productInstruction(product)"
          (delete)="deleteProduct(product)"
        />
      </li>
    }
  </ul>
</sd-border-wrapper>

@if (productCustomerSelected) {
  <sd-border-wrapper class="c__save-product">
    <sd-title [titleLevel]="3" customClass="brand--h5 is-main">
      {{ 'myProduct.saveProduct.title' | translate }}
    </sd-title>
    <p class="is-semi-bold is-text-dark">
      {{ 'myProduct.saveProduct.subtitle' | translate }}
    </p>
    <p>{{ 'myProduct.saveProduct.description' | translate }}</p>
    <sd-product-customer
      #productSelectedRef
      [indexFollow]="productCustomerSelected?.indexFollow"
      [titleLevel]="4"
      [isRegistered]="true"
      [productInfo]="productCustomerSelected"
      [showAllRef]="true"
    />
    <div class="c__actions d-flex justify-content-end" style="margin-top: 20px">
      <a sd-button (click)="cancelSave()" [isSecondary]="true">
        {{ 'myProduct.deleteProduct.cancel' | translate }}
      </a>
      <button sd-button (click)="addProductAsset()">
        <span>{{ 'myProduct.saveProduct.title' | translate }}</span>
      </button>
    </div>
  </sd-border-wrapper>
} @else {
  <wc-sis-categories
    [hasBorder]="true"
    [showAllRef]="true"
    (selectedProduct)="selectProduct($event)"
  />
}

@if (isLoading) {
  <div sd-loader></div>
}

@defer (when isConfirmModalOpened) {
  <sd-modal-default
    [(isOpened)]="isConfirmModalOpened"
    [noPadding]="true"
    [modalTitleLevel]="4"
    [modalTitle]="'myProduct.deleteProduct.confirmTitle' | translate"
  >
    <div sd-modal-body>
      <sd-product-customer
        [indexFollow]="productCustomerDeleted?.indexFollow"
        [titleLevel]="4"
        [isReadOnly]="true"
        [isRegistered]="true"
        [hasNoActions]="true"
        [productInfo]="productCustomerDeleted"
      />
      <footer class="c__modal-actions" sd-modal-footer>
        <a sd-button (click)="cancelSwitch()" [isSecondary]="true">
          {{ 'myProduct.deleteProduct.cancel' | translate }}
        </a>
        <button sd-button (click)="confirmDeleteAsset()">
          <span>{{ 'myProduct.deleteProduct.confirm' | translate }}</span>
        </button>
      </footer>
    </div>

    @if (modalIsLoading) {
      <div sd-loader></div>
    }
  </sd-modal-default>
}
